import { StatusObj } from "../Utility/StatusObj"

class EventHandler {

    DragOver(Arr, cell, IndexRow, IndexColumn, index, ColumnArr, RowArr, Refs, DragMode) {
        let ColumnArrLength
        let RowArrLength
        let ColumnMax
        let ColumnMin
        let RowMin
        let RowMax
        if (!ColumnArr.includes(IndexColumn)) {
            ColumnArr.push(IndexColumn)
        }
        if (!RowArr.includes(IndexRow)) {
            RowArr.push(IndexRow)
        }
        ColumnMax = Math.max(...ColumnArr)
        ColumnMin = Math.min(...ColumnArr)
        RowMax = Math.max(...RowArr)
        RowMin = Math.min(...RowArr)
        ColumnArrLength = ColumnArr.length
        RowArrLength = RowArr.length
        for (let i = ColumnMin; i <= ColumnMax; i++) {
            for (let j = RowMin; j <= RowMax; j++) {
                let INDEX = (i * 48) + j
                if (Refs[INDEX] && DragMode === 'add' && cell.status === StatusObj.NotAvailable) {
                    if (Arr[INDEX].status === StatusObj.NotAvailable) {
                        Refs[INDEX].classList.add('o__Schedule__Cell--DragAdd')
                    }
                } else if (Refs[INDEX] && DragMode === 'remove' && cell.status === StatusObj.Available) {
                    if (Arr[INDEX].status === StatusObj.Available) {
                        Refs[INDEX].classList.add('o__Schedule__Cell--DragRemove')
                    }
                }
            }
        }

        let ColumnCondition = Math.abs(ColumnArr[ColumnArrLength - 1] - IndexColumn) === 1;
        let RowCondition = Math.abs(RowArr[RowArrLength - 1] - IndexRow) === 1
        if (ColumnCondition) {
            if (IndexColumn > ColumnArr[ColumnArrLength - 1]) {
                for (let i = ColumnMin; i < IndexColumn; i++) {
                    for (let j = RowMin; j <= RowMax; j++) {
                        let INDEX = (i * 48) + j
                        Refs[INDEX].classList.remove('o__Schedule__Cell--DragAdd')
                    }
                }
                let filterColumnArr = ColumnArr.filter(each => each >= IndexColumn)
                ColumnArr = filterColumnArr
            }
            if (IndexColumn < ColumnArr[ColumnArrLength - 1]) {
                for (let i = IndexColumn; i <= ColumnMax; i++) {
                    for (let j = RowMin; j <= RowMax; j++) {
                        let INDEX = (i * 48) + j
                        Refs[INDEX].classList.remove('o__Schedule__Cell--DragAdd')
                    }
                }
                let filterColumnArr = ColumnArr.filter(each => each <= IndexColumn)
                ColumnArr = filterColumnArr
            }
        }
        if (RowCondition) {
            if (IndexRow > RowArr[RowArrLength - 1]) {
                for (let i = ColumnMin; i <= ColumnMax; i++) {
                    for (let j = RowMin; j <= IndexRow; j++) {
                        let INDEX = (i * 48) + j
                        Refs[INDEX].classList.remove('o__Schedule__Cell--DragAdd')
                    }
                }
                let filterRowArr = RowArr.filter(each => each >= IndexRow)
                RowArr = filterRowArr
            }
            if (IndexRow < RowArr[RowArrLength - 1]) {
                for (let i = ColumnMin; i <= ColumnMax; i++) {
                    for (let j = IndexRow; j <= IndexRow; j++) {
                        let INDEX = (i * 48) + RowMax
                        Refs[INDEX].classList.remove('o__Schedule__Cell--DragAdd')
                    }
                }
                let filterRowArr = RowArr.filter(each => each <= IndexRow)
                RowArr = filterRowArr
            }
        }
    }
    CalendarDragEnd(Data, setData, Arr, firstDay, ColumnArr, RowArr, Refs, DragMode, step) {
        let newData = [...Data];
        let CellSelectedIndex = []
        let CellUnSelected = []

        if (DragMode === 'add') {
            Refs.forEach((each, i) => each.classList[4] === 'o__Schedule__Cell--DragAdd' && CellSelectedIndex.push(i))

            CellSelectedIndex.forEach((Index) => {
                let newDateObj = {
                    ID: Arr[Index].ID,
                    // key: IDGenerator.DateTimeIndexFormat(Index, firstDay, step),
                    key: Arr[Index].key,
                    Index: Index,
                    date_time_from: Arr[Index][`date_time`],
                    date_time_to: Arr[Index + 1][`date_time`],
                    Status: StatusObj.Available,
                    initialStatus: Arr[Index].initialStatus
                }
                if (newData.filter(each => each.ID !== null && each.ID !== 0 && each.ID === newDateObj.ID && each.key === null && each.Status === 2).length !== 0) {
                    let i = newData.findIndex(each => each.ID !== null && each.ID !== 0 && each.ID === newDateObj.ID && each.key === null && each.Status === 2)
                    newData[i].Status = StatusObj.Available
                } else if (newData.filter(each => each.key == newDateObj.key).length === 0) {
                    newData.push(newDateObj)
                } else {
                    let i = newData.findIndex(each => each.key === newDateObj.key)
                    newData[i].Status = StatusObj.Available
                }

            })
        }
        if (DragMode === 'remove') {
            Refs.forEach((each, i) => each.classList[4] === 'o__Schedule__Cell--DragRemove' && CellUnSelected.push(i))
            CellUnSelected.forEach((Index) => {
                let newDateObj = {
                    ID: Arr[Index].ID,
                    key: Arr[Index].key,
                    // key: IDGenerator.DateTimeIndexFormat(Index, firstDay, step),
                    Index: Index,
                    isUpdated: true,
                    date_time_from: Arr[Index][`date_time`],
                    date_time_to: Arr[Index + 1][`date_time`],
                    Status: StatusObj.NotAvailable,
                    initialStatus: Arr[Index].initialStatus
                }
                if (newData.filter(each => each.ID !== null && each.ID !== 0 && each.ID === newDateObj.ID && each.key === null && each.Status === 2).length !== 0) {
                    let i = newData.findIndex(each => each.ID !== null && each.ID !== 0 && each.ID == newDateObj.ID && each.key === null && each.Status === 2)
                    newData[i].Status = newDateObj.Status
                    // newData[i].isUpdated = newDateObj.isUpdated
                    // newData[i].key = newDateObj.key
                } else if (newData.filter(each => each.key === newDateObj.key).length === 0) {
                    newData.push(newDateObj)
                } else {
                    let i = newData.findIndex(each => each.key === newDateObj.key)
                    newData.splice(i, 1)
                }
            })
        }
        CellSelectedIndex.forEach((Index) => {
            Refs[Index].classList.remove('o__Schedule__Cell--DragAdd')
        })
        CellUnSelected.forEach((Index) => {
            Refs[Index].classList.remove('o__Schedule__Cell--DragRemove')
        })
        setData(newData)
        ColumnArr = []
        RowArr = []
    }
    WeeklyDragEnd(TimeSlot, setTimeSlot, Arr, ColumnArr, RowArr, Refs, DragMode) {
        let newTimeSlot = [...TimeSlot];
        let CellSelectedIndex = []
        let CellUnSelected = []
        if (DragMode === 'add') {
            Refs.forEach((each, i) => each.classList[4] === 'o__Schedule__Cell--DragAdd' && CellSelectedIndex.push(i))
            CellSelectedIndex.forEach((Index) => {
                let timeSlots = newTimeSlot.filter(each => each.Index && each.Index === Index)
                let timeIndex = newTimeSlot.indexOf(timeSlots[0])
                if (timeIndex >= 0) {
                    newTimeSlot[timeIndex].status = StatusObj.Available;
                } else {
                    newTimeSlot.push(
                        {
                            Index: Index,
                            isUpdated: true,
                            Start: Arr[Index].Start,
                            End: Arr[Index].End,
                            status: StatusObj.Available
                        }
                    )
                }
            })
        }
        if (DragMode === 'remove') {
            Refs.forEach((each, i) => each.classList[4] == 'o__Schedule__Cell--DragRemove' && CellUnSelected.push(i))
            CellUnSelected.forEach((Index, i) => {
                let timeSlots = newTimeSlot.filter(each => each.Index && each.Index === Index)
                let timeIndex = newTimeSlot.indexOf(timeSlots[0])
                let brokenSlots = newTimeSlot.filter(brk => brk.Start <= Arr[Index].Start && Arr[Index].End <= brk.End)
                if (brokenSlots.length > 0) {
                    let I = newTimeSlot.findIndex(brk => brk.Start <= Arr[Index].Start && Arr[Index].End <= brk.End)
                    newTimeSlot.push(
                        {
                            isUpdated: true,
                            Start: newTimeSlot[I].Start,
                            End: Arr[Index].Start,
                            status: StatusObj.Available
                        },
                        {
                            isUpdated: true,
                            Start: Arr[Index].End,
                            End: newTimeSlot[I].End,
                            status: StatusObj.Available
                        }
                    )
                    newTimeSlot.splice(I, 1)
                } else if (timeIndex >= 0) {
                    newTimeSlot[timeIndex].status = 0
                    newTimeSlot.splice(timeIndex, 1)
                    CellSelectedIndex.splice(i, 1)
                } else {
                    newTimeSlot.push(
                        {
                            Index: Index,
                            isUpdated: true,
                            Start: Arr[Index].Start,
                            End: Arr[Index].End,
                            status: StatusObj.NotAvailable
                        }
                    )
                }
            })
        }
        setTimeSlot(newTimeSlot)
        CellSelectedIndex.forEach((Index) => {
            Refs[Index].classList.remove('o__Schedule__Cell--DragAdd')
            Refs[Index].classList.add('o__Schedule__Cell')
        })
        CellUnSelected.forEach((Index) => {
            if (Refs[Index]) {
                Refs[Index].classList.remove('o__Schedule__Cell--DragRemove')
                Refs[Index].classList.add('o__Schedule__Cell')
            }
        })
        ColumnArr = []
        RowArr = []
    }
    CalendarClick(Data, setData, Arr, firstDay, index, step, DragMode) {
        let newData = [...Data];
        let newDateObj = {
            ID: Arr[index].ID,
            key: Arr[index].key,
            Index: index,
            date_time_from: Arr[index][`date_time`],
            date_time_to: Arr[index + 1][`date_time`],
            Status: DragMode === 'add' ? StatusObj.Available : StatusObj.NotAvailable
        }
        if (newData.filter(each => each.ID != null && each.ID != 0 && each.ID == newDateObj.ID && each.key == null).length != 0) {
            let i = newData.findIndex(each => each.ID != null && each.ID != 0 && each.ID == newDateObj.ID && each.key == null)
            newData[i].Status = newDateObj.Status
        } else if (newData.filter(each => each.key === newDateObj.key).length === 0) {
            newData.push(newDateObj)
        } else {
            let i = newData.findIndex(each => each.key === newDateObj.key)
            if (DragMode === 'add') {
                newData[i].Status = StatusObj.Available
            } else {
                newData.splice(i, 1)
            }
        }

        setData(newData)
    }
    WeeklyClick(TimeSlot, setTimeSlot, Arr, cell, index, DragMode) {
        if (DragMode === 'add' && Arr[index].status === StatusObj.NotAvailable) {
            let newTimeSlot = [...TimeSlot];
            let newDateObj = {
                Index: index,
                isUpdated: true,
                Start: Arr[index].Start,
                End: Arr[index].End,
                status: StatusObj.Available
            }
            if (!newTimeSlot.includes(cell)) {
                newTimeSlot.push(newDateObj)
                setTimeSlot(newTimeSlot)

            }
        }
        if (DragMode === 'remove' && Arr[index].status === StatusObj.Available) {
            let newTimeSlot = [...TimeSlot];
            let newDateObj = {
                Index: index,
                isUpdated: true,
                Start: Arr[index].Start,
                End: Arr[index + 1].Start,
                status: StatusObj.NotAvailable
            }
            let timeSlots = newTimeSlot.filter(each => each.index && each.Index === index)
            let timeIndex = newTimeSlot.indexOf(timeSlots[0])
            let brokenSlots = newTimeSlot.filter(brk => brk.Start <= Arr[index].Start && Arr[index].End <= brk.End)
            if (brokenSlots.length > 0) {
                let I = newTimeSlot.findIndex(brk => brk.Start <= Arr[index].Start && Arr[index].End <= brk.End)
                let NewSlotBeforeTimm = Object.assign({}, newTimeSlot)
                newTimeSlot.splice(I, 1)
                if (NewSlotBeforeTimm[I].Start < Arr[index].Start) {
                    newTimeSlot.push(
                        {
                            isUpdated: true,
                            Start: NewSlotBeforeTimm[I].Start,
                            End: Arr[index].Start,
                            status: StatusObj.Available
                        })
                }
                if (Arr[index].End < NewSlotBeforeTimm[I].End) {
                    newTimeSlot.push(
                        {
                            isUpdated: true,
                            Start: Arr[index].End,
                            End: NewSlotBeforeTimm[I].End,
                            status: StatusObj.Available
                        }
                    )
                }
            } else {
                newTimeSlot.push(newDateObj)
            }
            setTimeSlot(newTimeSlot)
        }
    }
}
export default new EventHandler